import api from '../../../api/_patient'

export default {
    getPatient(patient_id) {
        return new Promise((resolve, reject) => {
            api.getPatient(patient_id).then(resolve, reject)
        })
    },

    getInfoAssurePrincipal(patient_id) {
        return new Promise((resolve, reject) => {
            api.getInfoAssurePrincipal(patient_id).then(resolve, reject)
        })
    },

    getInfoPersonneAPrevenir(patient_id) {
        return new Promise((resolve, reject) => {
            api.getInfoPersonneAPrevenir(patient_id).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeTousPatients(data) {
        return new Promise((resolve, reject) => {
            api.getListeTousPatients(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListePatients() {
        return new Promise((resolve, reject) => {
            api.patients().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getInfoAssurancePatient(patient_id) {
        return new Promise((resolve, reject) => {
            api.getInfoAssurancePatient(patient_id).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}
